// The shape shared by the "Custom" and "From file" markers (#972, #974): both are the same
// small chip and differ only in colour, so the geometry lives in one place.
export const BADGE_BASE =
    'inline-flex items-center rounded px-1.5 py-px text-[10.5px] font-semibold leading-4 align-middle whitespace-nowrap';
